import { render } from "./ListHead.vue?vue&type=template&id=04be4c4b&scoped=true"
import script from "./ListHead.vue?vue&type=script&lang=js"
export * from "./ListHead.vue?vue&type=script&lang=js"

import "./ListHead.vue?vue&type=style&index=0&id=04be4c4b&lang=less&scoped=true"

import exportComponent from "/builds/ChinaApplicationPool/dia/smart-search/mobile-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04be4c4b"]])

export default __exports__